import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-button-back',
  templateUrl: './button-back.component.html',
  styleUrls: ['./button-back.component.css'],
})
export class ButtonBackComponent implements OnInit {
  @Input() buttonNgClass: any = {
    btn: true,
    'btn-default': true,
    'btn-secondary': true,
  };
  @Input() buttonDisabled: boolean = false;
  @Input() buttonHTML: string = 'Cancel';

  constructor() {}

  ngOnInit() {}

  onBackClick() {
    window.history.back();
  }
}
